
import React from 'react';
import { Col, Row, Button, Form, Select } from 'antd';

const DataVisualizationFilterForm = () => {
    return (      
        <Form
            name="full_width_inline_form"
            layout="inline"
            className='filterTabsVisualization'
            style={{ width: '100%', paddingTop: '25px', paddingBottom: '25px', justifyContent: 'center', backgroundColor: '#f7f4f4' }}
        >
            <Row gutter={[18, 24]} style={{ width: '100%', alignItems: 'center' }}>
                <Col span={10} xs={24} sm={12} lg={12} xl={8} style={{ textAlign: 'start'}}>                           
                    <Form.Item label="Filter 1" style={{ width: '100%' }}>
                        <Select
                            //defaultValue="lucy"     
                            //onChange={handleChange}
                            placeholder="Filter 1"
                            // options={[
                            //     {
                            //     value: 'jack',
                            //     label: 'Jack',
                            //     },
                            //     {
                            //     value: 'lucy',
                            //     label: 'Lucy',
                            //     },
                                
                            // ]}
                        />
                    </Form.Item>
                </Col>
                <Col span={10} xs={24} sm={12} lg={12} xl={8} style={{ textAlign: 'start'}}>                           
                    <Form.Item label="Filter 2" style={{ width: '100%' }}>
                        <Select placeholder="Filter 2"/>
                    </Form.Item>
                </Col>
                <Col span={4} xs={24} sm={24} lg={24} xl={8} style={{ textAlign: 'start'}}>                           
                    <Form.Item style={{ width: '100%', alignItems: 'start' }}>
                        <Button className="btnPrimary" type="primary" style={{ padding: '22px 20px', backgroundColor: '#1A481B'}}>Submit</Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>          
    );
}

export default DataVisualizationFilterForm;